import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'ten-pay-with-points-balance',
  templateUrl: './pay-with-points-balance.component.html',
  styleUrls: ['./pay-with-points-balance.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslateModule, CommonModule],
})
export class PayWithPointsBalanceComponent {
  @Input() public points: number;
  @Input() public fiatAmount: number;
  @Input() public fiatCurrency: string;
  @Input() public showCurrencyEquivalent = false;
  @Input() public profile: boolean;
}
